import { intlFormat, isFuture } from "date-fns";

import { ErrorElement } from "@/components/error-element";
import { LoadingScreen } from "@/components/loading-screen";
import { NoData } from "@/components/no-data";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

import { useNews } from "../api/get-news";

import { NewsForm } from "./news-form";

type NewsListProps = {
  congressId?: string;
};

function NewsList(props: NewsListProps) {
  const { t } = useTranslation();
  const { congressId } = props;
  const { data, isLoading, isError, isSuccess } = useNews(congressId);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isSuccess || isError) {
    return <ErrorElement />;
  }

  return (
    <div className="max-w-96 space-y-4">
      {data.length < 1 && (
        <NoData description={t("news.empty")} />
      )}

      {data.map((newsItem) => {
        const timeToDisplay = newsItem.sendNotificationAfter
          ? newsItem.sendNotificationAfter
          : newsItem.createdAt;

        return (
          <AccordionItem value={newsItem.id} key={newsItem.id}>
            <AccordionTrigger>
              <span className="mr-1 text-left">{newsItem.title}</span>
              <span
                className="ml-auto mr-2 text-sm lowercase text-muted-foreground"
                title={intlFormat(timeToDisplay, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              >
                {isFuture(timeToDisplay) ? t("news.scheduled") : t("news.sent")}
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <NewsForm
                onClose={() => {}}
                congressId={congressId ? congressId : undefined}
                initialData={newsItem}
              />
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </div>
  );
}

export { NewsList };
